"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var factorySvgIcon_1 = __importDefault(require("./utils/factorySvgIcon"));
var SvgSearch = function (props) {
    var color = props.color;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.032 16.618a9 9 0 10-1.414 1.414l3.675 3.675a1 1 0 001.414-1.414l-3.675-3.675zM11 18a7 7 0 110-14 7 7 0 010 14z", fill: color })));
};
exports.default = factorySvgIcon_1.default(SvgSearch);
//# sourceMappingURL=SvgSearch.js.map